import { Metadata } from '@redwoodjs/web';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';

export default function PortalSettingsPage() {
  return (
    <>
      <Metadata title="Portal Settings" />
      <PageHeader pageType={PageType.PortalSettings}></PageHeader>
      <PageBody>todo</PageBody>
    </>
  );
}
